'use client';

import { Icon } from '@workspace/lib/components/atoms/icons/Icon';
import { ICONS_MAP } from '@workspace/lib/constants/icons-map';
import type { BasicButtonProps } from '@workspace/lib/types/form-handlers';
import { cn } from '@workspace/lib/utils/cn';

interface IconAsButtonProps extends BasicButtonProps {
  iconName?: string;
  // When provided, the icon renders as an external link opening in a new tab.
  href?: string;
  className?: string;
}

const ICON_CLASS_NAME =
  'cursor-pointer transition duration-150 ease-out hover:scale-[1.02]';

export function IconAsButton({
  type,
  disabled,
  iconName,
  href,
  className,
  onClick,
}: IconAsButtonProps) {
  if (!iconName || !ICONS_MAP[iconName]) return null;

  const icon = <Icon iconKey={iconName} />;

  if (href) {
    return (
      <a
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        aria-disabled={disabled}
        className={cn(ICON_CLASS_NAME, className)}
      >
        {icon}
      </a>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      aria-disabled={disabled}
      onClick={onClick}
      className={cn(ICON_CLASS_NAME, className)}
    >
      {icon}
    </button>
  );
}
